import { Link } from "react-router-dom";

const sponsorCopy = (
  <>
    <strong>DOLO</strong>
    <span className="sponsor-line">
      SPONSORED BY THE <b>AL RIOTBALL CHAMPIONSHIP</b>
    </span>
    <span className="sponsor-num">CCCXX</span>
  </>
);

export function SponsorStrip() {
  return (
    <section className="sponsor-strip" data-testid="sponsor-strip-section">
      <Link
        to="/riotball"
        className="sponsor-strip-inner"
        data-testid="sponsor-strip-link"
        aria-label="Dolo — sponsored by the AL Riotball Championship CCCXX"
      >
        <span className="sponsor-glitch" data-testid="sponsor-riotball-logo">
          <img loading="lazy" src="/assets/al-riotball-plate.png" alt="AL Riotball" />
          <img loading="lazy" className="sponsor-glitch-copy sponsor-glitch-a" src="/assets/al-riotball-plate.png" alt="" aria-hidden="true" />
          <img loading="lazy" className="sponsor-glitch-copy sponsor-glitch-b" src="/assets/al-riotball-plate.png" alt="" aria-hidden="true" />
        </span>
        <span className="sponsor-copy">
          <span className="sponsor-ticker">
            {[0, 1, 2, 3].map((set) => (
              <span className="sponsor-ticker-set" aria-hidden={set > 0 ? true : undefined} key={set}>
                {sponsorCopy}
              </span>
            ))}
          </span>
        </span>
        <span className="sponsor-live">
          <i /> OFFICIAL SPONSOR
        </span>
      </Link>
    </section>
  );
}
